// フォーム入力開始トラッキングの共通ロジック

// フォーム入力開始イベントを送信する関数
export const sendFormInputStartEvent = () => {
  const storageKey = `form_input_start_${window.location.pathname}`
  if (sessionStorage.getItem(storageKey)) {
    return
  }
  if (window.gtag) {
    window.gtag('event', 'form_input_start', {})
    sessionStorage.setItem(storageKey, 'true')
  } else {
    sessionStorage.setItem(storageKey, 'true')
  }
}

// フォーム要素にイベントリスナーを設定する関数
export const setupFormInteractionTracking = () => {
  // まとめて監視
  const handler = (event) => {
    // 対象となる要素のみイベント処理
    const tagName = event.target.tagName.toLowerCase()
    if (['input', 'textarea', 'select', 'button'].includes(tagName) && event.target.closest('form')) {
      sendFormInputStartEvent()
    }
  }

  document.addEventListener('click', handler, true) // capture or bubble,どちらでも可
  document.addEventListener('focus', handler, true) // focusはcaptureが推奨

  return () => {
    document.removeEventListener('click', handler, true)
    document.removeEventListener('focus', handler, true)
  }
}

// ページ離脱時にsessionStorageの該当キーを消す関数
export const clearStorageKey = () => {
  const storageKey = `form_input_start_${window.location.pathname}`
  sessionStorage.removeItem(storageKey)
}

// イベントリスナーの設定とクリーンアップを行う関数
export const setupFormInputStartTracking = () => {
  // イベントトラッキング設定
  const cleanup = setupFormInteractionTracking()

  // ページ離脱時にsessionStorageの該当キーを消す
  window.addEventListener('popstate', clearStorageKey)
  window.addEventListener('beforeunload', clearStorageKey)

  // クリーンアップ関数を返す
  return () => {
    cleanup()
    window.removeEventListener('popstate', clearStorageKey)
    window.removeEventListener('beforeunload', clearStorageKey)
  }
}
